import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamManagementService } from '../../../Services/exam-management/exam-management.service';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { IAnswerChoice } from '../exam-agencies/mock-exam-question/mock-exam-question.component';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NotificationAddEditComponent } from '../../notification-management/notification-add-edit/notification-add-edit.component';
export interface IQuestion {
  Path_Name: any;
  Question_ID: string;
  Question_Text: any;
  Answer_Choices: AnswerChoice[];
  SelectedQuestion: boolean;
  ExtractQuestionsForMockExam: number;
  Number_Of_Answer_Choices: number;
  Total_Number_Of_Optional_Questions: number | null;
  Time_To_Answer_In_Seconds: number | null;
  Right_Answer_Default_Score: number | null;
  Wrong_Answer_Penalty_Default_Score: number | null;
  Optional_Question_Ind: boolean;
  TimeToAnswerInSeconds: number | null;
  RightAnswerDefaultScore: number | null;
  WrongAnswerPenaltyDefaultScore: number | null;
}

export interface AnswerChoice {
  Answer_Choice_Id: any;
  Answer_Choice_Text: any;
  Right_Answer_Ind: any;
  All_Of_The_Above_Or_None_Of_The_Above_Ind: any;
  selected: boolean;
  Answer_Selected_IND: string;
}

@Component({
  selector: 'app-add-edit-mock-exam-question',
  templateUrl: './add-edit-mock-exam-question.component.html',
  styleUrls: ['./add-edit-mock-exam-question.component.css'],
})
export class AddEditMockExamQuestionComponent implements OnInit {
  private destroy$ = new Subject<void>();
  questions: IQuestion[] = [];
  MockExamId: number;
  courseId: number;
  MockExamSequenceNumber: number;
  ExamAgencyName: string;
  CourseName: string;
  ExamYear: string;
  MocKExamSequenceNumber: number;
  subjectId: number;
  totalQuestions: number;
  subjectName: string;
  currentNumberOfQuestions: number;
  questionId: string | null;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ExamService: ExamManagementService,
    private readonly toaster: ToastrService,
    private location: Location,
    private modalServiceLocal: ModalService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    combineLatest([this.route.queryParams, this.route.params])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([queryParams, params]) => {
        this.courseId = +queryParams['c_id'];
        this.MockExamSequenceNumber = +queryParams['m_Seq'];
        this.ExamAgencyName = queryParams['eA_Name'];
        this.CourseName = queryParams['c_Name'];
        this.ExamYear = queryParams['eY_Name'];
        this.subjectId = +queryParams['s_id'];
        this.totalQuestions = +queryParams['t_q'];
        this.subjectName = queryParams['s_name'];
        this.questionId = queryParams['q_id'] ?? null;
        this.MockExamId = +params['id'];
        this.getQuestionsForMockExam(); // ✅ Now called after both params & queryParams are fetched
      });

      this.getMockExamQuestion()
  }

  getQuestionsForMockExam() {
    this.getMockExamQuestion()
    const request = {
      CourseTestId: this.MockExamId,
      CourseId: this.courseId,
      SubjectID: this.subjectId,
      NumberOfQuestions: this.totalQuestions,
      QuestionID: this.questionId,
    };
    this.ExamService.getQuestionForMockExam$(request).subscribe((res) => {
      this.questions = res;
      console.log(this.questions);
      if (this.questionId) {
        this.questions.forEach((question) => {
          question.SelectedQuestion = true;
          question.Answer_Choices.forEach((choice) => {
            choice.selected = choice.Answer_Selected_IND === 'Y';
          });
        });
      }
    });
  }


  onQuestionSelectionChange(item: IQuestion,event: any): void {

    const checked = event.target.checked;
    if(checked){
      this.currentNumberOfQuestions ++
    }
    else{
      this.currentNumberOfQuestions--
    }
    if (!item.SelectedQuestion) {
      // Unselect all choices except for the correct answer
      item.Answer_Choices.forEach((choice: any) => {
        if (choice.Right_Answer_Ind !== 'Y') {
          choice.selected = false;
        }
      });
    } else {
      const numChoices = item.Answer_Choices.length;
      const numToSelect = item.Number_Of_Answer_Choices;
      if (numToSelect < numChoices) {
        this.toaster.warning(
          `You can only select  ${numToSelect} of answers for this question `,
          'Warning',{timeOut:1300}
        );
      }

      if(numChoices<numToSelect){
                  this.toaster.warning(
          `You cannot select this question as only ${numChoices} answers are available for this question `,
          'Warning',{timeOut:1300}
        );
      }
      item.Answer_Choices.forEach((choice: any, idx: number) => {
        if (idx < item.Number_Of_Answer_Choices) {
          choice.selected = true;
        } else {
          choice.selected = false;
        }
      });
    }
  }
  getMockExamQuestion() {
    const payload = {
      CourseTestId: this.MockExamId,
      CourseTestStatusTypeCode: null,
    };
    this.ExamService.getMockExamQuestion(payload).subscribe((res) => {
    this.currentNumberOfQuestions =
    res?.find(e => e?.Subject_Name === this.subjectName)
    ?.Subject_Current_Number_Of_Question ?? 0;
    });
  }

  onAnswerSelectionChange(
    item: IQuestion,
    choice: AnswerChoice,
    event: Event
  ): void {
    const control = event.target as HTMLInputElement;
    const checked = control.checked;
    if (checked) {
      // If the choice is selected, unselect the question
      if (
        item.Answer_Choices &&
        item.Answer_Choices.filter((choice: any) => choice.selected).length <=
          item.Number_Of_Answer_Choices
      ) {
      } else {
        this.toaster.error(
          'You can not select more than ' +
            item.Number_Of_Answer_Choices +
            ' choices'
        );
        control.checked = false;
        choice.selected = false;
      }
    }
  }

  navigateBack() {
    this.location.back();
  }
  onSave() {

    if (this.questions) {
      const invalidQuestion = this.questions
        .filter((question) => question.SelectedQuestion)
        .find(
          (ques) =>
            ques.Answer_Choices.filter((e) => e.selected).length <
            ques.Number_Of_Answer_Choices
        );

      if (invalidQuestion) {
        this.toaster.error(
          `Please select total of ${invalidQuestion.Number_Of_Answer_Choices} Answer choices for question ${invalidQuestion.Question_ID}`,
          '',
          { timeOut: ConstantVars.ToastErrorTimeout }
        );
        return;
      }

      if (this.questions.some((question) => question.SelectedQuestion)) {
        const payload = {
          UDTTestQuestion: this.questions
            .filter((question) => question.SelectedQuestion) // ✅ Only include selected questions
            .map((question) => ({
              CourseTestId: this.MockExamId,
              QuestionId: question.Question_ID,
              QuestionNumber: 0,
              RightAnswerScore: question.RightAnswerDefaultScore ?? 0, // Ensure number type
              WrongAnswerScore: question.WrongAnswerPenaltyDefaultScore ?? 0, // Ensure number type
              TimeToAnswerInSeconds: question.TimeToAnswerInSeconds ?? 0, // Ensure number type
              OptionalQuestionInd:
                question.Optional_Question_Ind === true ? 'Y' : 'N',
              SelectedIND: 'Y', // Since only selected questions are included
            })),

          UDTTestQuestionAnswerChoice: this.questions
            .filter((question) => question.SelectedQuestion) // ✅ Only include selected questions
            .reduce((acc, question) => {
              const choices = question.Answer_Choices.map((choice) => ({
                CourseTestId: this.MockExamId,
                QuestionId: question.Question_ID,
                AnswerChoiceId: choice.Answer_Choice_Id ?? 0, // Ensure number type
                AnswerChoiceSequenceNumber: 0,
                SelectedIND: choice.selected ? 'Y' : 'N',
              }));
              return acc.concat(choices);
            }, [] as any[]),
        };

        this.ExamService.insertOrUpdateTestQuestion(payload).subscribe(
          (res) => {
            this.getMockExamQuestion()
            this.CreateNotification()
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
            // this.router.navigate(['exam-management/mock-exam-question'], {
            //   queryParams: {
            //     c_id: this.courseId,
            //     m_Seq: this.MockExamSequenceNumber,
            //     eA_Name: this.ExamAgencyName,
            //     c_Name: this.CourseName,
            //     eY_Name: this.ExamYear,
            //     s_id: this.subjectId,
            //     t_q: this.totalQuestions,
            //     s_name: this.subjectName,
            //     c_q: this.currentNumberOfQuestions,
            //   },
            // });
          },
          (error) => {
            console.log(error);

            this.toaster.error(error.error.Message, '', {
              timeOut: ConstantVars.ToastErrorTimeout,
            });
          }
        );
      }
    }
  }

    async CreateNotification(): Promise<boolean> {
      try {
        // Step 1: Ask for confirmation
        const result = await this.modalServiceLocal.open(
          'Confirmation',
          'Do you want to send notification to all the users about this Mock Exam?',
          'Yes',
          'No'
        );

        if (!result) {
          return false; // user cancelled
        }

        // Step 2: Open notification modal
        const modalRef = this.modalService.open(NotificationAddEditComponent, {
          centered: true,
          size: 'xl',
          windowClass: 'custom-modal-width-notification-course',
          backdropClass: 'custom-backdrop-notification'
        });

        // Pass data into modal
        modalRef.componentInstance.screenName = 'MockExam';
        modalRef.componentInstance.MaterialId = this.MockExamId

        // Step 3: Wait for modal close result
        const notificationResult = await modalRef.result
          .then((res: any) => res)
          .catch(() => false);

        return !!notificationResult;
      } catch (error) {
        console.error('CreateNotification dismissed or failed:', error);
        return false;
      }
    }


  setSelectedExamId(id: number | null) {
    this.ExamService.setSelectedExamId(id);
  }

  ngOnDestroy(): void {
    const currentUrl = this.router.url;

    const shouldKeepSelection =
    currentUrl.includes('Exam/MockExams') ||
      currentUrl.includes('Exam/MockExamsQuestion') ||
      currentUrl.includes('Exam/AddEditMockExamsQuestion');

    if (!shouldKeepSelection) {
      this.setSelectedExamId(null); // Clear the selection
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
